<div class="page-title-area title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>Our Attorneys</h2>

                <ul>
                    <li><a [routerLink]="homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Attorneys</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<section class="team-area team-area-two pt-100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".3s">
                    <img src="assets/img/attorney-details/Malik_Khalid_Mehmood.png" alt="Team">

                    <div class="team-inner">
                        <h3><a (click)="isValid = true; attorney = 'Malik Khalid Mehmood Walayet'" style="cursor: pointer;">Malik Khalid Mehmood Walayet</a></h3>
                        <span>Founding Partner</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".4s">
                    <img src="assets/img/attorney-details/Malik_Saqib_Mehmood_Khalid.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a (click)="isValid = true; attorney = 'Malik Saqib Mehmood Khalid (AHC)'" style="cursor: pointer;">Malik Saqib Mehmood Khalid</a></h3>
                        <span>Partner</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="row justify-content-center">

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".5s">
                    <img src="assets/img/attorney-details/Waqar_amin_Sheikh.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Waqar A. Sheikh (ASC)</a></h3>
                        <span>Senior Consultant</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Sheikh_Nadeem.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Nadeem Sheikh (ASC)</a></h3>
                        <span>Senior Consultant</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".3s">
                    <img src="assets/img/attorney-details/mian_abdul_rauf.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Mian Abdul Rauf (ASC)</a></h3>
                        <span>Senior Consultant</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="row justify-content-center">

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".4s">
                    <img src="assets/img/attorney-details/Khawar_munir.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Khawar Munir (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".5s">
                    <img src="assets/img/attorney-details/Misbah_Ashiq.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mrs. Misbah Ashaq (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Adil_mirza.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Adil Mehmood (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="row justify-content-center">

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Saqiba_basharat.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Miss Saqiba Basharat (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Muhammad_Usama_Rauf.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. M. Usama Rauf (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Ali_Irtaza.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Ali Irtaza (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

        </div>

        <div class="row justify-content-center">
            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Barrister_Shahzaib.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Malik Shahzaib (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-3">
                <div class="team-item wow fadeInUp" data-wow-delay=".6s">
                    <img src="assets/img/attorney-details/Zaeem_Khan.png" alt="Team">
                    
                    <div class="team-inner">
                        <h3><a>Mr. Zaeem Khan (AHC)</a></h3>
                        <span>Associate Partner</span>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</section>

<app-attorney-details *ngIf = "isValid" (isModalClosed)="closeModal($event)" [attorneyDetails]="attorney"></app-attorney-details>

